import { MenuItem, PrimeIcons } from "primeng/api";
import { RoutesEnum } from "src/app/constants/RoutesEnum";

export const navLinks: MenuItem[] = [
	{
		label: 'Mapa',
		routerLink: RoutesEnum.MyMachines,
		icon: PrimeIcons.MAP_MARKER
	},
	{
		label: 'Reportes',
		routerLink: RoutesEnum.MyReports,
		icon: PrimeIcons.CHART_LINE
	},
	{
		label: 'Alertas',
		routerLink: RoutesEnum.Alerts,
		icon: PrimeIcons.BELL
	},
	{
		label: 'Mantenimientos',
		routerLink: RoutesEnum.Maintenance,
		icon: PrimeIcons.SHIELD
	},
	{
		label: 'Opciones',
		icon: PrimeIcons.COG,
		items: [
			{
				label: 'Empresa',
				routerLink: RoutesEnum.Companies,
			},
			{
				label: 'Usuarios',
				routerLink: RoutesEnum.Users,
			},
			{
				label: 'Eventos',
				routerLink: RoutesEnum.Events,
			},
			{
				label: 'Reportes',
				routerLink: RoutesEnum.Reports,
			},
		]
	},
]
